export enum BlobType {
  // Text Formats
  PlainText = 'text/plain',
  HTML = 'text/html',
  CSS = 'text/css',
  JavaScript = 'text/javascript',
  JSON = 'application/json',

  // Image Formats
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  GIF = 'image/gif',
  WebP = 'image/webp',
  SVG = 'image/svg+xml',

  // Audio Formats
  MP3 = 'audio/mpeg',
  WAV = 'audio/wav',
  OGG_AUDIO = 'audio/ogg',
  AAC = 'audio/aac',

  // Video Formats
  MP4 = 'video/mp4',
  WebM = 'video/webm',
  OGG_VIDEO = 'video/ogg',

  // Application Formats
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  Excel = 'application/vnd.ms-excel',
  Word = 'application/msword',
  PowerPoint = 'application/vnd.ms-powerpoint',
  Binary = 'application/octet-stream',
}
